export default {
    "label.update_translations_unsuccessful": "",
    "global.no_records": "Ei merkintöjä",
    "notifications.rp_has_been_updated": "Projektia on muokattu",
    "moduleTitle.files": "Tiedostot",
    "label.coordinator": "Yhteyshenkilö",
    "sidebar.translations_managment": "Käännösten hallinta",
    "table.file": "Tiedosto",
    "label.report_overview": "Yleiskatsaus",
    "label.parent_agreement": "Tulostettava huoltajan lupa",
    "parentalConsent.i_consent_to_and_understand_that": "6. Hyväksyn ja ymmärrän, että tiettyihin Avartti-ohjelmaan liittyviin toimintoihin osallistuvasta osallistujasta voidaan ottaa valokuvia ja tällaisia valokuvia voidaan käyttää myynnin edistämistarkoituksiin edellyttäen, että sekä osallistuja että hänen vanhempansa/huoltajansa ovat allekirjoittaneet asianmukaisen luvan.",
    "parentalConsent.i_understand_that_participants_are_required_to_comply": "Ymmärrän, että osallistujien on noudatettava Saavutustenkirjaan sisältyviä vaatimuksia sekä asianomaisen Avartti-yksikön käytäntöjä ja sääntöjä.",
    "table.end_date": "Lopetuspäivä",
    "label.activation_date": "Suorituspäivä",
    "label.report": "Raportti",
    "label.award_is_offline": "Avartti on offline",
    "label.pending_changes": "Odottavat muutokset...",
    "errors.min_nights_required": "Vähintään {nights} yötä vaaditaan",
    "label.country": "Maa",
    "notifications.award_leader_has_been_returned": "Avartti-ohjaaja on tarkastettu",
    "notifications.participant_has_been_updated": "Osallistuja on päivitetty",
    "label.phone_number": "Puhelinnumero",
    "roles.aj_assessor": "Seikkailun arvioija",
    "notifications.person_state_has_been_changed": "Henkilön tila on muutettu",
    "pageTitle.dashboard": "Hallintapaneeli",
    "moduleTitle.global_payment_method": "Kansainvälinen maksutapa",
    "label.organization_type": "Organisaatiotyyppi",
    "button.account_settings": "Tilin asetukset",
    "notifications.contact_has_been_updated": "Yhteyshenkilö on päivitetty",
    "participant.recover_password": "Palauta salasana",
    "notifications.assessment_request_has_been_sent": "Arviointipyyntö on lähetetty",
    "button.unassign": "",
    "label.start_date": "Aloituspäivä",
    "label.assign_labels": "",
    "sidebar.participants": "Osallistujat",
    "roles.coordinator": "Yhteyshenkilö",
    "label.organization_contact": "Organisaation yhteystieto",
    "tabs.customization": "Muokkaus",
    "sidebar.award_units": "Avartti-toimijat",
    "button.change_goal": "Vaihda tavoitetta",
    "translationsManagement.selectProject": "Valitse projekti?",
    "award.rp": "Projekti",
    "label.size": "Koko",
    "label.bulk_action_results": "Bulk toimintojen tulokset",
    "notifications.activity_has_been_approved": "Aktiviteetti on hyväksytty",
    "label.payment_type": "Maksutapa",
    "button.gop_assignment": "",
    "button.resend_assessment_request": "Lähetä arviointipyyntö",
    "notifications.template_has_been_removed": "Mallipohja on poistettu",
    "button.award_settings": "Avartti asetukset",
    "pageTitle.payment": "Maksu",
    "tasks.return_award": "Tarkasta Avartti",
    "label.link": "linkki",
    "moduleTitle.award_participant_delete": "Poista osallistujan Avartti",
    "pageTitle.mro_related_contacts": "Aluetoimisto - Yhteystiedot",
    "pageTitle.my_organization_labels": "",
    "tabs.activity_signoff": "Osion hyväksyminen",
    "table.logs": "Lokit",
    "moduleTitle.remove_file": "Poista tiedosto?",
    "label.email_confirmed": "S-posti vahvistettu",
    "notifications.activity_has_been_returned": "Aktiviteetti on tarkastettu",
    "label.note": "Huomiot",
    "button.show": "Näytä",
    "tabs.adventurous_journey": "Seikkailu",
    "sidebar.my_todolist": "Tehtävälistani",
    "label.here": "täällä",
    "organisation.change_award_mode": "Vaihda Avartin tilaa",
    "table.note_from_al": "Viesti Avartti-ohjaajalta",
    "label.gender": "Sukupuoli",
    "moduleTitle.remove": "Poista?",
    "errors.must_be_less_than": "Täytyy olla vähemmän kuin {limit}",
    "button.logout": "Kirjaudu ulos",
    "label.no_selected_participants": "Ei valittuja osallistujia",
    "button.new_aj_event": "Uusi seikkailutapahtuma",
    "label.employement_status": "Työllisyystilanne",
    "tabs.logs": "Lokit",
    "tabs.contacts": "Yhteystiedot",
    "label.option": "Vaihtoehto",
    "dashboard.charts": "Listat",
    "notifications.rp_has_been_approved": "Projekti on hyväksytty",
    "pageTitle.new_participant": "Uusi osallistuja",
    "notifications.award_leader_has_been_approved": "Avartti-ohjaaja on hyväksytty",
    "moduleTitle.would_you_like_to_remove_leader_training": "Haluatko poistaa Avartti-ohjaajan koulutuksen?",
    "moduleTitle.update_configuration_value": "Päivitä määritysarvo",
    "table.description": "Kuvaus",
    "table.organization": "Organisaatio",
    "label.youtube": "YouTube",
    "label.author": "Tekijä",
    "table.suitable_for_award_level": "Soveltuu Avartti-tasolle",
    "label.content_update": "Odota. Sisältöä ladataan...",
    "notifications.new_question_has_been_added": "Uusi kysymys on lisätty",
    "pageTitle.nao_awards": "Avartti-säätiö - Tasot",
    "table.last_name": "Sukunimi",
    "moduleTitle.adventurous_journey_detail": "Seikkailun tiedot",
    "Description of the combo box selection in bulk operation panel": {"label.bulk_operations": "Bulk toiminto"},
    "label.project_location_type": "Projektin paikka",
    "label.email_help_award_level": "Avartin taso.",
    "label.date": "Päiväys",
    "label.previous_completed_award_place": "Missä",
    "button.show_more": "Näytä lisää",
    "label.wwc_number": "WWC number",
    "button.filter": "Suodata",
    "notifications.rp_has_been_returned": "Projekti on tarkastettu",
    "pageTitle.residetial_project_assessor_report": "Projektin - Arvioitsijan raportti",
    "label.generating": "Toiminto käynnissä...",
    "moduleTitle.finance_system_data": "Finance System Data",
    "notifications.adventurous_journey_state_has_been_changed": "Seikkailua on muutettu",
    "route.levels": "Tasot",
    "moduleTitle.activity_leader": "Lajiohjaaja",
    "tasks.approve_event": "Hyväksy tapahtuma",
    "tasks.reject_event": "Tarkasta tapahtuma",
    "table.region": "Alue",
    "pageTitle.nao_award_leaders": "Avartti-säätiö - Ohjaajat",
    "errors.must_be_at_least": "Pitää olla vähintään {min} merkkiä",
    "table.title": "Titteli",
    "table.last_activity": "Viimeisin aktiviteetti",
    "tasks.delete_registration": "Poista kirjautuminen",
    "table.date_time": "Paikallinen aika",
    "parentalConsent.the_award_operators_are_committed_to_respecting": "14. Avartti-toimijat ovat sitoutuneet kunnioittamaan yksityisyyttäsi. Tällä lomakkeella kerätään henkilötietoja Avarttiin osallistumista varten. Osallistujat, jotka eivät toimita meille näitä tietoja, eivät voi osallistua toimintaan. Voimme myös käyttää henkilötietojasi lähettääksemme sinulle tietoja muista Avartti-aktiviteeteista tai tapahtumista, joiden uskomme kiinnostavan sinua. Saatamme jakaa tiedot muille paikallisille tai kansainvälisille organisaatioille ja palveluntarjoajille, jotka auttavat meitä Avartin toiminnassa ja hallinnoinnissa. Jos haluat ottaa meihin yhteyttä tai päästä käsiksi henkilötietoihisi, kirjoita Avartti-yksikköösi. Voit myös ottaa yhteyttä Avartti-yksikköösi pyytääksesi kopion heidän tietosuojakäytännöstään.",
    "aj.practice_journey": "Harjoitusseikkailu",
    "notification.log_has_been_restored": "Aktiviteetti loki on tallennettu",
    "tabs.my_participants": "Osallistujani",
    "label.bulk_action_assign_label": "",
    "moduleTitle.supervisor": "Valvoja",
    "moduleTitle.your_parental_consent": "Huoltajan lupa",
    "route.registration_participants": "Osallistujien kirjaaminen",
    "placeholder.start_typing": "Kirjoita...",
    "tasks.approve_award": "Hyväksy Avartti",
    "route.registrations": "Kirjautumiset",
    "button.add_activity": "Lisää aktiviteetti",
    "notifications.aj_event_has_been_created": "Seikkailutapahtuma on luotu",
    "states.supervisor_approval": "Arvioijan raportti",
    "label.description": "Kuvaus",
    "button.leave_anyway": "Poistu silti",
    "tabs.registrations": "Kirjautumiset",
    "states.leader_signoff": "Osion hyväksyntä",
    "moduleTitle.forbidden": "Ei sallittu",
    "notifications.translations_has_been_updated.button": "Käännökset ladattu onnistuneesti",
    "pageTitle.nao_registration": "Avartti-säätiö - Kirjautuminen",
    "pageTitle.mro_logs": "Aluetoimisto - Lokit",
    "meta.page_not_found": "Sivua ei löydy",
    "label.bulk_action_unsuccessful": "{count} kohdetta epäonnistui:",
    "global.days": "päivät",
    "table.review": "Tarkasta",
    "table.as_assessor_for": "Arvioija",
    "roles.if_staff_statistical_user": "IF Statistical User",
    "table.levels": "Tasot",
    "label.suitable_for_level": "Sopiva tasolle",
    "pageTitle.leaders": "Ohjaajat",
    "moduleTitle.send_test_email": "Lähetä testi s-posti",
    "pageTitle.tasks_removed_registration": "Poista osallistujan rekisteröityminen",
    "label.you_will_be_forced_to_login_again_after_change": "Sinun täytyy kirjautua uudelleen",
    "table.recent_updates": "Huomautuksia ja viimeisimmät päivitykset",
    "pageTitle.tasks_activity_signoffs": "Osion kirjaaminen",
    "pageTitle.payments": "Maksut",
    "global.nights": "yöt",
    "label.blank_any_level": "TYHJÄ millä tahansa tasolla",
    "button.view_section": "Näytä osio",
    "moduleTitle.select_organization": "Valitse organisaatio",
    "pageTitle.manual_data_import": "Manuaalinen tietojen tuonti",
    "button.upload_files": "Lisää tiedostoja",
    "label.migrated_contact_email": "Siirretty yhteyssähköposti",
    "label.for_award_unit": "Avartti-toimijoille",
    "label.aj_template_note": "Mallipohja huomio",
    "table.last_log_added": "Viimeisin loki lisätty",
    "button.view_participant": "Osallistujalta",
    "label.please_comment_on_the_participants": "Lisää kommentti osallistujan etenemisestä/suorituksesta/sitoutumisesta",
    "label.consent_already_given_login": "Lupa on jo myönnetty. Kirjaudu sisään lapsenasi.",
    "participant.level_start_date": "{value} Aloituspäivä",
    "sidebar.my_region_office": "Aluetoimistoni",
    "states.section_signoff": "Osion valtuutus",
    "moduleTitle.assessor_details": "Arvioijan tiedot",
    "moduleTitle.adventurous_journey_settings": "Seikkailun asetukset",
    "moduleTitle.note_from_al": "Viesti Avartti-ohjaajalta",
    "button.add_role": "Lisää rooli",
    "table.run": "Käytä",
    "states.change_to_state_warning_missing_assessment": "Varoitus: Arviointi puuttuu. Haluatko silti jatkaa?",
    "label.user_app_guide_leader": "Käyttöohjeet - ohjaaja",
    "tabs.section_approval": "Osion hyväksyminen",
    "roles.award_verifier": "Avartti tunnustettu",
    "tabs.activity_approval": "Aktiviteetin hyväksyminen",
    "logs.add_log": "Lisää lokia",
    "tabs.award": "Avartti",
    "notifications.this_role_has_read_only_persmission": "Sinulla on vain luku-oikeudet",
    "table.no_filtered_results": "Ei tuloksia",
    "button.praise": "Kommentti",
    "label.prevent_welcome_email_assessor": "Älä lähetä tervetuloa-spostia arvioitsijalle",
    "label.location_detail": "Paikan tiedot",
    "label.optional": "(valinnainen)",
    "errors.do_not_match": "Ei täsmää",
    "label.use_comma_for_multiple_entries": "Käytä pilkkua lisätäksesi useita",
    "label.operating_authority": "Yhteistyökumppani",
    "label.activity_section": "Aktiviteetti osio",
    "notifications.you_have_been_logged_out": "Sinut on kirjattu ulos",
    "table.finished": "Valmis",
    "button.same_as_billing": "Sama kuin laskutusosoite",
    "table.payment": "Maksu",
    "table.current_level": "Nykyinen taso",
    "button.view_nao": "Palautettu Avartti-säätiön puolesta (viestin kera)",
    "table.email_confirmation": "S-posti vahvistettu",
    "moduleTitle.shipping_address": "Toimitusosoite",
    "label.secondary_phone_type": "Toinen puhelin malli",
    "notifications.saved": "Tallennettu",
    "pageTitle.all_participants": "Kaikki osallistujat",
    "label.first_name": "Etunimi",
    "label.oa_price": "OA hinta",
    "table.award_mode": "Avartin tila",
    "tabs.api_keys": "API avaimet",
    "award.award_detail": "Avartin tiedot",
    "tabs.user_management": "Käyttäjien hallinnointi",
    "tabs.all_events": "Kaikki tapahtumat",
    "notifications.history_record_has_been_removed": "Historia merkintä on poistettu",
    "award.no_data": "Ei dataa",
    "notifications.preparation_training_has_been_added": "Harjoitus on lisätty",
    "label.message": "Viesti",
    "notifications.participant_info_updated": "Osallistujan tiedot on päivitetty",
    "roles.nao_staff": "KAT henkilöstö",
    "tabs.adventurous_journeys": "Seikkailut",
    "label.gops": "",
    "route.upload": "Lataa",
    "notifications.history_record_has_been_added": "Historia merkintä on lisätty",
    "notifications.history_record_has_been_updated": "Historia merkintä on päivitetty",
    "label.no_data": "Ei dataa",
    "button.add_coordinator": "Lisää yhteystieto",
    "label.you_are_already_logged_as": "Olet jo kirjautunut tilillä ",
    "route.my_national_office": "Kansallinen toimistoni",
    "tabs.leaders": "Ohjaajat",
    "label.email_confirmation": "S-posti varmennus",
    "table.registration_date": "Päiväys",
    "notifications.role_has_been_removed": "Rooli on poistettu",
    "button.move": "Siirrä",
    "label.terms_and_conditions": "Käyttöehdot",
    "pageTitle.detail": "Lisätiedot",
    "table.award_unit": "Avartti-toimija",
    "sidebar.settings": "Asetukset",
    "dashboard.leader_state": "Ohjaajat-alueittain",
    "notifications.award_unit_has_been_approved": "Avartti-toimija on hyväksytty",
    "states.awaiting_approval": "Odottava valtuutus",
    "table.level": "Taso",
    "table.action_requested": "Vaatii toimenpiteitä",
    "label.organisation_mode": "Organisaation tila",
    "label.no_note": "Ei huomioita",
    "tabs.my_events": "Tapahtumani",
    "notifications.participants_have_been_added": "Osallistujat on lisätty",
    "tabs.registration_questions": "",
    "button.delete_registration": "Poista kirjautuminen",
    "notifications.parental_consent_link_has_been_sent": "Huoltajan lupa-linkki on lähetetty",
    "moduleTitle.select_role_organization": "Valitse rooli & organisaatio",
    "label.experience": "Kokemus",
    "translationsManagement.modal.title": "Haluatko ladata päivitykset käännöksiin?",
    "table.ic": "Itsenäinen valtio",
    "table.id": "ID",
    "label.notify_email_explanation": "Osallistujalle ilmoitetaan sähköpostitse, että hänen arviointipyyntöään ei ole hyväksytty, ja häntä pyydetään korjaamaan s-posti ja pyytämään arviointia uudelleen.",
    "participant.would_you_like_to_remove": "Haluatko poistaa tämän tilin?",
    "table.fields_included": "Mukana kentät",
    "label.user_guide_web_leader": "Käyttöohjeet - Ohjaaja",
    "label.journey_type": "Seikkailun muoto",
    "button.setup": "Luo",
    "tabs.my_national_office": "Kansallinen toimistoni",
    "notifications.training_has_been_removed": "Harjoitus on poistettu",
    "label.nominated_and_identified_persons": "Henkilöt jotka voivat katsoa tietoja",
    "moduleTitle.you_have_been_logged_out_due_to_inactivity": "Sinut on kirjattu ulos",
    "states.award_leader_signoff": "Avartti-ohjaajan valtuutus",
    "table.award_signoff_attempts": "Yritykset kirjata Avartti",
    "sidebar.regions": "Alueet",
    "label.activity_deleted_note": "Tämä toiminto on poistettu. Voit palauttaa sen klikkaamalla alla olevaa painiketta.",
    "table.total": "Yhteensä",
    "errors.a_problem_has_occured_during_processing": "Ongelmia on ilmennyt toiminnon aikana, katso lisätietoa",
    "participant.participant_already_has_gold_award": "Osallistuja on jo tehnyt kultatason",
    "pageTitle.mro": "Aluetoimistoni",
    "notifications.authorization_code_has_expired": "Valtuutuskoodi on vanhentunut",
    "moduleTitle.child_organization_labels": "",
    "aj.aj_events": "Seikkailutapahtumat",
    "global.loading": "Ladataan",
    "label.gnipp": "GNIPP / ALF Disc %",
    "sidebar.registrations": "Kirjautumiset",
    "label.any_string": "Any string",
    "contact.change_contact_status": "Vaihda yhteystietoja",
    "tabs.registration": "Kirjaa",
    "label.override_payment_note": "Ohita maksutosite",
    "notifications.section_has_been_signed_off": "Osiosta on kirjauduttu ulos",
    "label.payment_date": "Maksun päiväys",
    "button.approve": "Hyväksy",
    "moduleTitle.loggin_in": "Kirjautuminen",
    "label.website": "Nettisivu",
    "label.role": "Rooli",
    "table.assessor_report": "Arvioijan raportti",
    "label.ue_fe": "User Engagement Frontend (osallistujien staattiset verkkotunnisteet)",
    "label.please_comment_on_the_participants_effort": "",
    "label.previously_worked_as_assessor": "Aikaisempi kokemus arvioitsijana",
    "pageTitle.registrations": "Kirjautuminen",
    "parentalConsent.this_form_must_be_completed": "Tämä lomake <strong>täytyy</strong> täyttää vanhemman tai huoltajan toimesta, jos osallistuja on alle <strong> 18-vuotias/asuinmaasi lakisääteinen ikäraja</strong>.",
    "button.apply": "Aseta",
    "errors.include_at_least_one_number": "Lisää vähintään yksi numero",
    "label.content_restore": "Ladataan...",
    "logs.hour": "tunti",
    "parentalConsent.i_have_read_and_understand": "Olen tutustunut Avartti-ohjelman rakenteeseen ja sen vaatimuksiin, jotka on esitelty tämän lomakkeen viimeisellä sivulla.",
    "notifications.award_was_deleted": "Avartti poistettiin.",
    "label.journey_category": "Seikkailun muoto",
    "notifications.search_cancelled": "Toiminto keskeytettiin, odota että toiminto on valmis.",
    "route.detail": "Lisätiedot",
    "route.user_guide": "Käyttöohjeet",
    "moduleTitle.history": "Historia",
    "table.gop_name": "",
    "pageTitle.tasks_unassigned_participants": "Määrittämättömät osallistujat",
    "states.inactive": "Arkisto",
    "pageTitle.search_results": "Etsinnän tulokset",
    "button.proceed_to_login": "Siirry kirjautumiseen",
    "pageTitle.assessor_report_reject": "Muokkaa arvraporttia",
    "notifications.contact_has_been_removed": "Yhteyshenkilö on poistettu",
    "sidebar.operating_authorities": "Yhteistyökumppanit",
    "label.no_note_from_participant": "Ei viestiä osallistujalta",
    "aj.preparation_and_training": "Valmistelu ja harjoittelu",
    "route.user_guide_web_leader": "Käyttöohjeet - Ohjaajat",
    "label.position_in_organization": "Rooli organisaatiossa",
    "errors.emails_dont_match": "S-posti ei täsmää",
    "route.my_participants": "Osallistujani",
    "pageTitle.customisations": "Mukautukset",
    "tabs.localization_files": "Paikannustiedostot",
    "table.assessor_approval": "Arvioijan raportti",
    "tabs.related_contacts": "Yhteystiedot",
    "table.aus": "Avartti-toimijat",
    "table.category": "Kategoria",
    "errors.file_is_too_large": "Latauksen enimmäiskoko on 20 Mt",
    "label.possible_values": "Mahdolliset:",
    "label.if_your_download_doesnt_start": "Jos lataaminen ei alkanut, paina tästä",
    "route.independent_award_centres": "Itsenäiset Avartti-toimijat",
    "pageTitle.user_guide": "Käyttöohjeet",
    "button.visit": "Vieraile",
    "label.hours_first_letter": "h",
    "pageTitle.my_organization_detail": "Organisaationi - Tiedot",
    "pageTitle.nao_detail": "Avartti-säätiön tiedot",
    "button.change": "Muuta",
    "award.aj": "Seikkailu",
    "table.award_state": "Avartin tila",
    "pageTitle.tasks_award_signoff": "Avartin kirjaaminen",
    "pageTitle.regions": "Alueet",
    "notifications.award_has_been_signed_off": "Avartti on kirjattu ulos",
    "dashboard.award_approved_by": "Hyväksytyt tunnustukset - 2016",
    "tabs.new_template": "Uusi mallipohja",
    "error.parent_email_must_be_filled": "Huoltajan s-posti on lisättävä",
    "label.organisation_invoicing_name": "Lisenssin haltija",
    "pageTitle.related_contacts": "Liittyvät yhteystiedot",
    "button.try_again": "Sulje varoitus ja kokeile uudestaan",
    "label.cannot_be_change_to_another": "Ei voi vaihtaa eri tasolle",
    "notifications.lead_coordinator_has_been_set": "Uusi pääyhteyshenkilö on asetettu",
    "label.training_name": "Harjoituksen nimi",
    "moduleTitle.new_contact": "Uusi yhteystieto",
    "translationsManagement.modal.updateTitle": "Oletko varma?",
    "moduleTitle.offline_award_units_signoff": "Offline Avartti-ohjaajan kirjaus",
    "notifications.award_level_has_been_changed": "Avartti-taso on muutettu",
    "label.subject": "Aihe",
    "route.silver_level": "Hopeataso",
    "label.privacy_notice": "Tietosuojailmoitus",
    "label.switch_organization": "Vaihda organisaatiota",
    "meta.dofe_name": "Kansainvälinen Avartti-ohjelma",
    "route.profile": "Profiili",
    "roles.super_user": "Super-user",
    "dashboard.while_you_were_gone": "Poissaollessasi",
    "label.no_note_from_award_leader": "Palautettu Avartti-säätiön puolesta  (ilman viestiä)",
    "label.middle_name": "Toinen nimi",
    "moduleTitle.new_activity": "Uusi aktiviteetti",
    "organisation.would_you_like_to_remove": "Haluaisitko poistaa tämän organisaation?",
    "label.state_province": "Alue",
    "moduleTitle.your_home_address": "Kotiosoite",
    "tabs.sign_offs": "Valtuutukset",
    "moduleTitle.logs": "Lokit",
    "button.view_more": "Katso lisää",
    "label.profile": "Profiili",
    "label.title": "Titteli",
    "tabs.award_signoff": "Avartin hyväksyminen",
    "label.post_code": "Postinumero",
    "states.ceremony_certificate": "Tilaisuus",
    "label.code": "",
    "parentalConsent.i_consent_to_the_provision_of_any": "",
    "label.user_guide_web_participant": "Käyttöohjeet - Osallistuja",
    "label.award_unit_type": "Avartti-toimijan tyyppi",
    "states.complete": "Valmis",
    "table.participant_state": "Osallistujan tila",
    "pageTitle.my_organization_payment": "Organisaationi - Maksu",
    "table.approved": "Valtuutus",
    "pageTitle.my_organization_contacts": "Organisaation yhteistiedot",
    "warning.award_marked_as_paid_registration": "Varoitus: Tämä Avartin rekisteröinti on merkitty maksetuksi. Tutustu maksu- ja palautusohjeisiin ennen vahvistamista.",
    "states.change_to_state": "Tee muutoksia <strong>{state}</strong>",
    "label.integer": "Kokonaisluku",
    "notifications.translationUpdateInterrupted": "Päivitys keskeytyi",
    "notifications.password_has_been_changed": "Salasana on vaihdettu",
    "button.invite_assessor": "Kutsu arvioitsija",
    "label.other_activity": "Muu aktiviteetti",
    "notifications.parental_consent_has_been_sent": "Huoltajan lupa on lähetetty",
    "button.revise": "Tarkista",
    "errors.end_date_must_be_after_start_date": "Päättymisen tulee olla alkamisen jälkeen",
    "label.award_leader_signoff_date": "Avartti-ohjaajan valtuutuksen päiväys",
    "parentalConsent.i_understand_every_participant_must": "8. Ymmärrän, että jokaisen osallistujan on osallistuttava Avartti-ohjelmaan Avartti-yksikön kautta, jolla on harkintavalta hyväksyä tai hylätä osallistujan suoritus ohjelmassa etenemisessä.\n",
    "moduleTitle.policies": "Käytännöt",
    "pageTitle.tasks_aj": "Seikkailu",
    "global.day": "päivä",
    "moduleTitle.coordinator": "Yhteyshenkilö",
    "label.region": "Alue",
    "button.add_history_record": "Lisää historia merkintä",
    "moduleTitle.adventurous_journey_template_settings": "Seikkailun mallipohjien asetukset",
    "notifications.personal_details_have_been_updated": "Tiedot on päivitetty",
    "sidebar.ics": "Itsenäiset valtiot",
    "table.independent_award_centre": "Itsenäinen Avartti-keskus",
    "label.undelivered_mail_reason": "Syy ettei s-posti ole lähtenyt",
    "table.utc_date_time": "UTC aika",
    "moduleTitle.emails": "S-postit",
    "label.backoffice": "Backoffice",
    "moduleTitle.parent_consent": "Vanhemman/huoltajan lupa",
    "label.photo_consent_given": "Osallistuja suostuu siihen, että voimme käyttää hänen profiilikuvaansa myynninedistämiseen",
    "moduleTitle.authorising_contact": "Hyväksyjän yhteystiedot",
    "label.assessment_with_role": "{role} arviointi",
    "dashboard.type_of_awards": "Avartti-toimijan muoto",
    "moduleTitle.payment": "Maksu",
    "states.in_progress": "Vaiheessa",
    "logs.no_logs": "Ei lokeja",
    "sidebar.my_office": "Toimistoni",
    "label.assessor_report": "Arvioijan raportti",
    "notifications.rp_has_been_signed_off": "Projekti on kirjattu ulos",
    "tabs.labels": "",
    "sidebar.payments": "Maksut",
    "meta.profile_questions": "Profiilikysymykset",
    "label.fax": "Faxi",
    "label.email_help_custom_link": "Mukautettu linkki, jos se on asetettu.",
    "label.last_name": "Sukunimi",
    "organisation.manage_gop": "",
    "table.parental_consent": "Huoltajan lupa",
    "dashboard.participant_by_level": "Osallistujat - tasoittain",
    "tabs.award_leaders": "Avartti-ohjaajat",
    "label.i_confirm_that_ive_witnessed": "Vakuutan, että olen tarkastanut osallistujan lokikirjasta seuraavat aktiviteetit",
    "table.lead_coordinator": "Pääyhteyshenkilö",
    "states.deleted": "Poistettu",
    "label.no_answers": "Ei vastausta",
    "button.add": "Lisää",
    "label.exchequer_number": "Exchequer A/c No.",
    "label.waiting": "Odottaa",
    "label.email_help_person_full_name": "Henkilön koko nimi.",
    "tasks.return_registration": "Tarkasta kirjautuminen",
    "notifications.state_aj_preparation_training_has_been_changed": "Seikkailuun valmistautumisen tila on muutettu.",
    "label.parent_approval": "Huoltajan lupa",
    "table.assessor_approve": "Arvioijan hyväksyntä",
    "errors.some_fields_requires_your_attention": "Jotkin kohdat kaipaavat huomiota",
    "aj.qualifying_journey": "Varsinainenseikkailu",
    "route.awards": "Tunnustus",
    "table.registration": "Kirjaus",
    "pageTitle.assessors": "Arvioitsijat",
    "notifications.award_has_been_updated": "Avartti-taso on päivitetty",
    "errors.must_be_one_of": "Pitää olla joku näistä: {enums}",
    "pageTitle.logs": "Lokit",
    "notifications.notifications.invitation_has_been_sent": "Kutsu on lähetetty",
    "route.national_offices": "Kansalliset toimistot",
    "notifications.training_has_been_updated": "Harjoitusta on muokattu",
    "label.parent_last_name": "Vanhempi / Huoltajan nimi",
    "table.leaders": "Ohjaajat",
    "states.award_level_complete": "Avartti-taso suoritettu",
    "button.reset": "Nollaa",
    "sidebar.my_award_unit": "Oma Avartti-toimija",
    "pageTitle.all_aj_events": "Kaikki seikkailutapahtumat",
    "label.activity": "Aktiviteetti",
    "moduleTitle.are_you_sure": "Oletko varma?",
    "route.gold_level": "Kultataso",
    "table.evidence": "Todiste",
    "label.delivery_confirmed": "Lähetys vahvistettu",
    "parentalConsent.as_the_parent": "Vanhempana / huoltajana annan suostumuksen kuvien käyttämiseen Avartti-säätiön viestinnällisiin tarkoituksiin.",
    "label.awardMode.offline": "Offline",
    "tasks.approve_registration": "Hyväksy kirjautuminen",
    "note.change_the_email_will_change": "Huomaa: Sähköpostin muuttaminen muuttaa myös Siirretty yhteyshenkilön sähköpostiosoitteen",
    "notifications.participant_has_been_approved": "Osallistuja on hyväksytty",
    "label.reached_activity_limit": "Tässä osiossa on saavutettu toimintaraja. Osallistujalla voi olla enintään 3 aktiviteettia kussakin osiossa.",
    "label.facebook": "Facebook",
    "notifications.label_has_been_removed": "",
    "label.action_required": "",
    "notifications.preparation_training_has_been_removed": "Harjoitus on poistettu",
    "pageTitle.settings": "Asetukset",
    "participant.level_registration_date": "{value} Rekisteröitymisen päivämäärä",
    "notifications.question_has_been_removed": "Kysymys poistettu",
    "label.email_help_award_leader_full_name": "Ohjaajan koko nimi.",
    "sidebar.leaders": "Ohjaajat",
    "notifications.participants_have_been_transferred": "Osallistujat on siirretty",
    "tabs.assessors": "Arvioitsijat",
    "sidebar.dashboard": "Hallintapaneeli",
    "pageTitle.independent_award_centers": "Itsenäiset Avartti-toimijat",
    "label.search": "Etsi",
    "moduleTitle.office_labels": "",
    "label.note_from_participant": "Osallistujan huomiot",
    "errors.required_field": "Pakollinen kenttä",
    "tasks.approve_task": "Hyväksy tehtävä",
    "logs.edit_log": "Muokkaa lokia",
    "table.state": "Tilanne",
    "moduleTitle.level_summary": "Tasojen yhteenveto",
    "moduleTitle.guides": "Ohjeet",
    "modal.close": "Sulje",
    "label.parent_first_name": "Vanhempi / Huoltajan etunimi",
    "parentalConsent.i_understand_that_the_participant": "1. Ymmärrän, että osallistuja ei voi osallistua Avarttiin ennen kuin tämä lomake on täytetty (mukaan lukien vanhemman / huoltajan suostumus) ja palautettu asianomaiselle Avartti-toimijalle, sovellettavan rekisteröintimaksun kanssa ja Avartti-toimijan hyväksyttyä rekisteröitymisen.",
    "tabs.award_units": "Avartti-toimijat",
    "table.hours": "Tunnit",
    "label.type": "Laji",
    "notifications.adventurous_journey_has_been_removed": "Seikkailu on poistettu",
    "label.aj_is_not_approved_yet": "Seikkailua ei ole vielä hyväksytty",
    "roles.authorizing_contact": "Valtuuttajan yhteystiedot",
    "table.date_submitted_to_office_signoff": "Päivä, jona toimitettu Avartti-säätiön valtuutukseen",
    "notifications.section_has_been_returned": "Osio on tarkastettu",
    "table.created_by": "Luonut",
    "route.user_guide_web_participant": "Käyttöohjeet - Osallistujat",
    "route.templates": "Mallipohjat",
    "states.awaiting_sign_off": "Avartti-ohjaajan valtuutus",
    "table.phone": "Puhelin",
    "label.parental_consent": "Huoltajan lupa",
    "label.org_contact_will_be_deleted": "",
    "route.bronze_level": "Pronssitaso",
    "label.invoice_currency": "Laskun valuutta",
    "button.new_label": "",
    "error.server_cannot_be_reached_at_the_moment": "Serveriin ei saada yhteyttä. Kokeile myöhemmin uudelleen.",
    "notifications.contact_has_been_created": "Yhteyshenkilö on luotu",
    "pageTitle.profile_questions": "Profiilikysymykset",
    "table.observation_files": "Huomio tiedostot",
    "table.participants": "Osallistujat",
    "tasks.no_evidence": "Todistetta ei ole lisätty",
    "button.edit": "Muokkaa",
    "moduleTitle.leader": "Ohjaajat",
    "notifications.new_template_has_been_updated": "Uusi mallipohja on päivitetty",
    "table.name": "Nimi",
    "label.no_results": "Ei tuloksia",
    "moduleTitle.documents": "Tiedostot",
    "button.invite": "Kutsu",
    "label.goal": "Tavoite",
    "pageTitle.nao_award_units": "Avartti-säätiö - Toimijat",
    "label.award_delete_participant_id": "Osallistujan ID",
    "errors.at_least_num_characters": "Vähintään {length} merkkiä pitkä",
    "label.email_help_note": "Mukautettu huomautus, jos se on asetettu.",
    "label.person_status.activating": "label.person_status.activating",
    "moduleTitle.remove_role": "Poista rooli?",
    "label.total": "Yhteensä",
    "label.delete_participant_award_info": "Olet poistamassa Avartti-tason. Tämä on peruuttamatonta. Säännöt:\na) osallistujalla on oltava enemmän kuin palkintoja\nb) pisin aktiviteetti nollataan, jos se vaadittiin poistettavalla tasolla\nc) jos poistamisen jälkeen on jäljellä kaksi Avartti-tasoa, pisin aktiviteetti asetetaan alemmalle tasolle, vain siinä tapauksessa, ettei sen tila ole myöntämisen auth/completed/ceremony state. ",
    "route.leaders": "Ohjaajat",
    "table.start_date": "Aloituspäivä",
    "moduleTitle.coordinators": "Yhteyshenkilöt",
    "button.create": "Luo",
    "tabs.awards": "Tunnustus",
    "parentalConsent.form_has_been_sent": "Huoltajan lupa on lähetetty.",
    "states.journey_approval": "Seikkailun valtuutus",
    "pageTitle.reports": "Raportti",
    "table.journey_type": "Seikkailun tyyppi",
    "label.yes": "Kyllä",
    "pageTitle.assessor_report": "Arvioijan raportti",
    "label.organization": "Organisaatio",
    "notifications.award_leader_has_been_updated": "Avartti-ohjaaja on päivitetty",
    "moduleTitle.edit_role": "Muuta roolia",
    "table.journey_activity": "Seikkailun aktiviteetti",
    "label.location": "Paikka",
    "label.update_translations_error_item": "",
    "pageTitle.adventurous_journeys": "Seikkailu",
    "global.assessor": "Arvioija",
    "moduleTitle.profile_questions": "Profiilikysymykset",
    "activity.cannot_edit_activity_if_award_in_state": "Ei voi muokata, sillä Avartti on {state} tilassa",
    "moduleTitle.assessor_detail": "Arvioijan tiedot",
    "parentalConsent.i_understand_that_upon_acceptance_into": "10. Ymmärrän, että osallistuja saa aloittaessaan Avartti-ohjelman pääsyn Saavutustenkirjaan (ORB). Osallistuja lukee Saavutustenkirjassa olevat ohjelman vaatimukset ennen Avartin aloittamista. Ymmärrän, että Avartti-yksiköllä on harkintavalta päättää, ovatko palkinnon vaatimukset täyttyneet ja  myönnetäänkö pronssi-, hopea- vai kultatunnustus. Ymmärrän, että järjestäjä saattaa tarjota osallistujille rajoitetun tapaturma- ja vastuuvakuutuksen, mutta vastuu tapaturmaturvan hankkimisesta ja ylläpidosta on osallistujalla/ja hänen huoltajalla.",
    "notifications.award_has_been_returned": "Taso on tarkastettu",
    "label.code_of_conduct": "Menettelyohje",
    "button.new_contact": "Uusi kontakti",
    "tabs.payments": "Maksut",
    "roles.naa_oa_staff": "NAA OA Staff",
    "label.switch_organisation_hint": "Voit palata tähän valitsemalla 'Vaihda organisaatiota' ylhäällä oikealla olevasta valikosta",
    "label.expiration_date": "Päättymispäivä",
    "tabs.participants": "Osallistujat",
    "table.practice": "Harjoitus",
    "notifications.one_activity_has_to_remain": "Yksi aktiviteetti tulee pysyä aktiivisena",
    "label.qualifications": "Suoritukset",
    "states.organization_approval": "Avartti-toimijan valtuutus",
    "errors.must_be_an_integer": "Pitää olla kokonaisluku",
    "participant.send_confirmation_email_again_question": "Lähetä viesti uudelleen?",
    "button.dismiss": "Hylkää",
    "table.advice": "Vinkki",
    "label.years_of_working_experience": "Työkokemus vuosissa",
    "notifications.search_failed": "Jokin meni pieleen. Kokeile myöhemmin uudelleen.",
    "notifications.changes_have_been_saved": "Muutokset on tallennettu",
    "moduleTitle.resend_parental_consent_link": "Lähetä uudestaan huoltajan lupa-linkki?",
    "label.activity_type": "Aktiviteetin tyyppi",
    "label.change_award": "Vaihda Avartti-tasoa",
    "label.email": "S-posti",
    "button.remove": "Siirrä",
    "button.download": "Lataa",
    "label.vat_treatment": "ALV tiedot",
    "pageTitle.aj_template_new": "Seikkailun uusi mallipohja",
    "table.per_page": "sivulla",
    "notifications.translations_has_been_updated": "Käännökset on päivitetty",
    "notification.award_mode_has_been_updated": "Avartin tilaa on muokattu",
    "tasks.revise_item": "Tarkasta kohde",
    "button.resend_parental_consent": "Lähetä uudelleen huoltajan suostumus",
    "table.weeks_completed_required": "Viikot Suoritettu / Vaadittu",
    "label.last_modified": "Viimeiksi muokattu",
    "table.major": "Pisin",
    "label.vat_number": "ALV nro.",
    "errors.passwords_dont_match": "Salasana ei täsmää",
    "table.country": "Maa / Alue",
    "sidebar.guides_and_policies": "Oppaat ja käytännöt",
    "notifications.question_has_been_updated": "Kysymys päivitetty",
    "table.participant_name": "Osallistujan nimi",
    "label.registration_approval_date": "Rekisteröinnin hyväksymispäivä",
    "notifications.auth_code_is_no_longer_valid": "Valtuutuskoodi on vanhentunut",
    "errors.must_be_no_more_than": "Saa olla enintään {max} merkkiä",
    "notifications.event_has_been_rejected": "Tapahtuma on tarkastettu",
    "tabs.customizations": "Mukautukset",
    "label.name_organization": "Nimi",
    "button.add_log": "Lisää loki",
    "moduleTitle.invite_assessor": "Kutsu arvioitsija",
    "label.resend_confirmation_email": "Lähetä vahvistus s-posti uudelleen",
    "text.all_participants_will_be_transfered": "Kaikki osallistujat siirretään uudelle Avartti-ohjaajalle",
    "label.repeat_email": "Toista s-posti",
    "errors.email_or_phone_required": "S-posti tai puhnumero on lisättävä",
    "notifications.role_has_been_updated": "Rooli on päivitetty",
    "roles.if_staff_stat_user": "IF Statistical User",
    "participant.delete_account": "Poista yhteystieto",
    "moduleTitle.would_you_like_to_remove_this_log": "Haluatko poistaa tämän lokin?",
    "sidebar.sgops": "",
    "label.prepare_new_email": "Valmistele uusi sähköposti",
    "table.journey_category": "Seikkailun muoto",
    "sidebar.manual_data_import": "Manuaalinen datan tuonti",
    "label.created_after_date": "Luotu jälkeen",
    "route.my_organization": "Organisaationi",
    "button.show_list": "Näytä lista",
    "label.leaders": "Ohjaajat",
    "notifications.log_has_been_modified": "Lokia on muokattu",
    "button.upload_file": "Lataa tiedosto",
    "moduleTitle.which_section_do_you_want_to": "Minkä osion haluat palauttaa tilaan 'Kesken'?",
    "tabs.bronze_level": "Pronssitaso",
    "notifications.participants_have_been_saved": "Osallistujat on tallennettu",
    "pageTitle.aj_template_detail": "Seikkailu",
    "label.parent_email": "Vanhemman&#39;s / Huoltajan&#39;s S-posti",
    "map.appr_location": "Likimääräinen osoite:",
    "notifications.log_has_been_removed": "Loki on poistettu",
    "notifications.label_has_been_assigned": "",
    "pageTitle.tasks_undelivered_emails": "Ei lähteneet s-postit",
    "button.stay": "Jää",
    "table.previous_level": "Aikaisempi taso",
    "label.award_start_date": "Avartin aloittamispäivämäärä",
    "assessor_report.returned_to_participant": "Palautettu osallistujalle",
    "pageTitle.tasks_assessors_registration": "Arvioijan kirjautuminen",
    "aj.cannot_modify_award": "Avartti-tasoa ei voi muuttaa jos osallistujat on jo määritetty Seikkailuun",
    "moduleTitle.lost_internet_connection": "Internet-yhteys katkesi",
    "states.ceremony": "Tilaisuus",
    "participant.reactivate_account": "Palauta tili käyttöön",
    "label.birthdate": "Syntymäaika",
    "pageTitle.assessment_send_successfully": "Arviointi on lähetetty",
    "states.assessor_approval": "Arvioijan raportti",
    "award.change_award_level": "Vaihda Avartti-tasoa",
    "label.url_no_longer_valid": "Tämä URL ei enää toimi.",
    "button.update": "Päivitys",
    "label.secondary_email": "Toissijainen sähköposti",
    "button.role_edit": "Muokkaa",
    "table.award_leader": "Avartti-ohjaaja",
    "label.level": "Taso",
    "tasks.evidence": "Todiste",
    "notifications.participant_is_already_in_list": "Osallistuja on jo listalla",
    "button.clear": "Tyhjennä",
    "label.allow_log_after_25_yoa": "Hyväksy lokit yli 25-vuotialta",
    "states.setup": "Luo",
    "table.activity": "Aktiviteetti",
    "label.copy_to_clipboard": "{text} kopioitiin.",
    "route.award_units": "Avartti-toimija",
    "button.upload_photo": "Lataa kuva",
    "table.hours_completed_required": "Valmis / Vaaditaan",
    "table.first_name": "Etunimi",
    "notifications.adventurous_journey_has_been_returned": "Seikkailua on muutettu",
    "pageTitle.national_offices": "Avartti-säätiö",
    "notifications.you_have_been_logged_in": "Sinut on kirjattu sisään",
    "logs.offline": "Offline",
    "moduleTitle.add_role": "Lisää rooli",
    "label.user_app_guide_participant": "Käyttöohjeet - osallistuja",
    "notifications.file_has_been_removed": "Tiedosto on poistettu",
    "label.send_message": "Lähetä viesti",
    "button.select": "Valitse",
    "label.reason_of_deletion": "Poistamisen syy",
    "label.user_guide": "Käyttöohjeet",
    "pageTitle.nao_participants": "Avartti-säätiö - Osallistujat",
    "tabs.sub_operating_partners": "",
    "table.uploaded_by": "Lähettäjä",
    "tasks.approve_item": "Hyväksy kohde",
    "tasks.restore_participant_registration": "Säilytä osallistujan rekisteröityminen?",
    "label.awardMode.hybrid": "Hybridi",
    "table.first_activity_started": "Aloituspäivä",
    "moduleTitle.dates": "Päivämäärät",
    "table.no_results": "Ei tuloksia",
    "states.registration_approval": "Kirjautumisen valtuutus",
    "table.breakdown_of_hours": "Tuntierittely",
    "pageTitle.tasks_registration": "Osallistujen rekisteröityminen",
    "button.create_new": "Luo uusi",
    "sidebar.todolist": "Tehtävälista",
    "label.active_participants": "Aktiiviset osallistujat",
    "moduleTitle.postalAddress": "moduleTitle.postalAddress",
    "tasks.return_task": "Tarkasta tehtävä",
    "organisation.change_organisation_state": "Vaihda organisaation tyyppiä",
    "moduleTitle.roles": "Roolit",
    "label.no_config_key_available": "Tälle osalle ei ole käytettävissä määritysavaimia",
    "placeholder.selectLanguage": "Valitse kieli",
    "states.office_signoff": "Avartti-toimijan valtuutus",
    "notifications.translations_has_been_updated.failure": "Käännöksen päivittäminen epäonnistui",
    "logs.minute": "minuutti",
    "label.last_activity": "Viimeinen aktiviteetti",
    "sidebar.user_guide": "Käyttöohjeet",
    "label.trained_award_leader": "koulutettu Avartti-ohjaaja",
    "table.progress": "Prosessi",
    "table.suboperating_authorities": "Alihankkija",
    "activity.cannot_edit_activity_offline": "Offline tila on tällä osallistujalla käytössä.<br><br>\nEt voi muokata; aktiviteettia, seikkailua tai projektia, silloin kun kyseinen käyttöliittymä on osittain offline tilassa.",
    "label.user_does_not_have_permissions": "Käyttäjällä <strong>{user}</strong> ei ole valtuutusta käyttää tätä sivua.",
    "notifications.assessor_has_been_approved": "Arvioitsija on valtuutettu",
    "route.activity_approval": "Aktiviteetin hyväksyntä",
    "moduleTitle.role": "Rooli",
    "button.run": "Käytä",
    "label.to": "To",
    "notifications.file_has_been_updated": "Tiedosto on päivitetty",
    "moduleTitle.edit_coordinator": "Muokkaa yhteyshenkilöä",
    "notifications.authorization_code_is_no_longer_valid": "Valtuutuskoodi on vanhentunut",
    "button.reject": "Tarkista",
    "label.label.participant_status": "Osallistujan tila",
    "award.gold_level": "Kultataso",
    "sidebar.variables": "Muuttujat",
    "parentalConsent.checkbox_copy": "Vahvistan, että olen {firstName} {lastName} vanhempi / huoltaja. Annan suostumukseni hänen osallistumiseen Avartti-toimijan {organisationName} ja koulutetun Avartti-ohjaajan valvonnassa. Olen lukenut, ymmärtänyt ja hyväksyn Avarttiin osallistumisen vaatimukset ja ehdot, jotka on kuvattu yllä ja Avartti-säätiön verkkosivuilla.",
    "button.go_to_dashboard": "Siirry hallintapaneeliin",
    "button.add_option": "Lisää vaihtoehto",
    "label.is_completed": "Valmis",
    "pageTitle.award_units": "Avartti-toimijat",
    "states.completed": "Suoritettu",
    "button.adventurous_journey_template_settings": "Seikkailun mallipohjien asetukset",
    "label.system_rights": "Käyttöoikeudet",
    "label.assessor_assesstment_award_start_date": "tunnustuksen arvioinnin aloittamispäivä",
    "label.update_translation_question": "",
    "button.login": "Kirjaudu",
    "label.name_of_the_unit": "Yksikön nimi",
    "button.send": "Lähetä",
    "award.ajs": "Seikkailut",
    "meta.payments_expired": "Maksut - Erääntyneet",
    "label.age": "Ikä",
    "notifications.payment_info_updated": "Maksutiedot on päivitetty",
    "table.is_completed": "Valmis",
    "table.invited_by": "Kutsunut",
    "route.files": "Tiedostot",
    "route.assessors": "Arvioitsija",
    "info.aj_supervisor_is_mandatory": "Harjoitusseikkailun arviointipyynnön saa valvoja ja Seikkailun arviointipyynnön saa arvioitsija.",
    "pageTitle.my_participants": "Omat osallistujat",
    "label.change_leader_status": "Vaihda ohjaajan statusta",
    "moduleTitle.parent_consent_form": "Vanhemman/huoltajan lupalappu",
    "notifications.authorization_contact_has_been_set": "Valtuuttajan tiedot on lisätty",
    "button.close": "Sulje",
    "label.independent_country": "Itsenäinen valtio",
    "notifications.aj_preparation_training_has_been_returned": "Harjoitusseikkailu on tarkastettu",
    "route.history_log": "Tehdyt lokit",
    "participant.account_settings": "Tilin asetukset",
    "label.bulk_action_error_item": "{globalId} {firstName} {lastName} {email} koska",
    "label.orb_account": "ORB tili",
    "notifications.file_url_is_not_specified_in_configuration": "Tiedoston URL-osoitetta ei ole määritetty",
    "notifications.award_unit_has_been_removed": "Avartti-yksikkö on poistettu",
    "table.parent": "Vanhempi",
    "label.mode_of_transport": "Liikkumistapa",
    "label.parental_consent_email_info": "Älä unohda tarkastaa osallistujan huoltajan yhteystietoja ja lähettää lupalappua manuaalisesti.",
    "label.current_award": "Taso tällä hetkellä",
    "table.action": "Toiminta",
    "pageTitle.suboperating_authorities": "Alihankkijat",
    "notifications.award_leader_has_been_assigned": "Avartti ohjaaja on määritetty",
    "tabs.sign_offs_locally": "Paikallinen valtuutus",
    "Activity log has been restored": "notification.log_has_been_restored",
    "sidebar.naos": "KAT",
    "tabs.aj_templates": "Seikkailun mallipohjat",
    "notifications.logging_out": "Kirjaudutaan ulos...",
    "label.update_label": "",
    "button.organisation_settings": "Organisaatioasetukset",
    "tabs.independent_award_centers": "Itsenäiset Avartti-keskukset",
    "label.current": "Nykyinen",
    "table.location": "Paikka",
    "button.search": "Etsi",
    "notifications.aj_preparation_training_has_been_approved": "Harjoitusseikkailu on hyväksytty",
    "route.participants": "Osallistujat",
    "label.other_location_information": "Lisätiedot paikasta",
    "label.number_of_records": "Merkintöjen määrä",
    "translationsManagement.infoLabel": "Käyttääksesi tätä sinun tulee ladata uusi POE-versio",
    "parentalConsent.i_consent_to_pay_all": "5. Suostun maksamaan kaikki tällaiset lääkäreille, sairaanhoitajille tai sairaalan majoitusmaksut ja kulut, jotka aiheutuvat osallistujan puolesta sellaisista onnettomuuksista, vammoista, sairaudesta tai menetyksistä, joita osallistuja on kohdannut osallistuessaan tai matkustaessaan Avartti-ohjelmaan liittyviin toimintoihin.",
    "label.nationality": "Kansallisuus",
    "states.approval": "Valtuutus",
    "notifications.something_went_wrong": "Jokin meni pieleen",
    "aj.practice": "Harjoitus",
    "label.addressLine2": "Osoite rivi 2",
    "label.please_leave_a_note": "Jätä viesti",
    "placeholder.select": "Valitse",
    "label.observations": "Huomiot",
    "label.aim": "Tavoite",
    "label.addressLine1": "Osoite rivi 1",
    "roles.aj_instructor": "Seikkailuohjaaja",
    "meta.payments_waiting": "Maksut - Odottavat",
    "label.award_to_delete": "Poistettava Avartti-taso",
    "label.category": "Kategoria",
    "roles.instructor": "Ohjaaja",
    "moduleTitle.remove_customization_and_reset": "Poistetaanko mukauttaminen ja palautetaanko konfigurointiarvo?",
    "notifications.participant_registration_has_been_restored": "Osallistujan rekisteröityminen on palautettu",
    "organisation.change_award_unit_mode": "Vaihda organisaation tilaa",
    "table.organization_type": "",
    "notifications.participant_has_been_deleted": "Osallistuja on poistettu",
    "label.language_settings": "Kieli",
    "notifications.event_has_been_approved": "Tapahtuma on hyväksytty",
    "label.password": "Salasana",
    "label.text": "Teksti",
    "table.observations": "Huomiot",
    "notifications.participant_has_been_created": "Osallistuja on luotu",
    "table.note_for_al": "Viesti Avartti-ohjaajalle",
    "label.payment_confirmed": "Maksu vahvistettu",
    "label.previous_completed_award_level": "Aikaisempi taso (ei ORB)",
    "pageTitle.new_aj_event": "Uusi seikkailutapahtuma",
    "label.backend": "Backend",
    "label.relationship_to_participant": "Huoltajuussuhde",
    "award.physical_recreation": "Liikunta",
    "contact.collect_emails": "Kerää sähköpostiosoitteita sähköpostin lähettämistä varten",
    "moduleTitle.assessor_report_reject": "Hylkää arvioijan raportti",
    "label.supervisor_report": "Valvojan raportti",
    "table.role": "Rooli",
    "route.user_guide_web_nao": "Käyttöohjeet - NAO",
    "label.page_not_found": "404 - sivua ei löydy.",
    "table.labels": "",
    "notifications.file_has_been_uploaded": "Tiedosto on ladattu",
    "moduleTitle.address": "Osoite",
    "moduleTitle.lead_coordinator": "Pääyhteyshenkilö",
    "pageTitle.login": "Sisäänkirjautuminen",
    "label.frontoffice": "Frontoffice",
    "participant.would_you_like_to_remove_registration": "Haluatko poistaa tämän rekisteröinnin?",
    "notifications.rp_has_been_setup": "Projekti on luotu",
    "moduleTitle.award_unit": "Avartti-toimija",
    "button.remove_file": "Poista tiedosto",
    "moduleTitle.billing_address": "Laskutusosoite",
    "pageTitle.my_aj_events": "Omat seikkailutapahtumat",
    "route.tasks": "Tehtävät",
    "button.confirm": "Vahvista",
    "label.national_award_authority": "National Award Authority",
    "label.independent_award_centre": "Yksityinen Avartti-keskus",
    "award.generate_award_report": "Luo raportti",
    "route.my_region_office_customization": "Alueellinen toimisto - Mukautukset",
    "label.email_help_aj_category": "Seikkailun muoto.",
    "label.your_report_has_been_rejected": "Olet hylännyt arvioinnin",
    "notifications.password_change_request_has_been_sent": "S-posti salasanan vaihdosta on lähetetty",
    "tabs.detail": "Lisätiedot",
    "participant.change_participant_status": "Vaihda osallistujan statusta",
    "table.key": "Avain",
    "label.find_address": "Etsi osoite",
    "notifications.assessor_has_been_rejected": "Arvioija on tarkastettu",
    "label.transfer_participants": "Siirrä osallistujat",
    "button.continue_to_payment_gateway": "Siirry maksamaan",
    "notifications.participant_registration_has_been_removed": "Osallistuja on siirretty",
    "moduleTitle.page_not_found": "404 - sivua ei löydy",
    "route.adventurous_journeys": "Seikkailu",
    "states.registration_assessment": "Kirjautumisen arviointi",
    "heading.change_award_unit_mode": "Muuta Avartti-toimijan tilaa",
    "label.user_guide_web_nao": "Käyttöohjeet - NAO",
    "tabs.silver_level": "Hopeataso",
    "table.paid_by": "Maksanut",
    "label.your_report_has_been_successfully_sent": "Raporttisi on lähetetty onnistuneesti.",
    "sidebar.my_organization": "Organisaationi",
    "pageTitle.participants": "Osallistujat",
    "notifications.preparation_training_has_been_updated": "Harjoitus on päivitetty",
    "moduleTitle.server_is_unreachable": "Serveriin ei saada yhteyttä",
    "label.last_activity_date": "Viimeisen aktiviteetin päiväys",
    "award.bronze_level": "Pronssitaso",
    "moduleTitle.award_units": "Avartti-toimijat",
    "table.completed": "Valmis",
    "moduleTitle.revise_message": "Tarkasta viesti",
    "table.lastUsed": "Viimeiksi käytetty",
    "award.bronze_to_gold_level": "Pronssista kultatasolle",
    "button.change_password": "Vaihda salasanaa",
    "label.nao_price": "NAO hinta",
    "label.payment_state": "Maksun tila",
    "label.wwc_expired": "WWC expired",
    "label.award_office_signoff_date": "Avartti-säätiön valtuutuksen päiväys",
    "label.award_unit": "Avartti-toimija",
    "award.gold_level_short": "Kulta",
    "moduleTitle.other_info": "Muut tiedot",
    "table.note": "Viesti",
    "label.search_by_email_first_or_last": "Etsi joko nimellä tai s-postilla",
    "tabs.history": "Historia",
    "notifications.label_has_been_created": "",
    "tabs.unassigned_participants": "Määrittelemättömät osallistujat",
    "table.main_award_leader": "Koordinaattori",
    "parentalConsent.i_as_the_parent": "3. Ymmärrän, että tietyt toiminnot katsotaan riskialttiiksi ja että suuren riskin toiminnot eivät välttämättä kuulu Avartti-operaattorin vakuutusjärjestelyjen piiriin. Ymmärrän, että vastuu kaikista riskeistä, jotka aiheutuvat osallistujan osallistumisesta Avarttiin, on yksinomaan osallistujalla.",
    "label.state": "Tilanne",
    "notifications.award_leader_has_been_removed": "Avartti-ohjaaja on poistettu",
    "tabs.organization_detail": "Organisaation lisätiedot",
    "table.operating_authorities": "Yhteistyökumppani",
    "label.available_labels": "",
    "modal.select": "Valitse",
    "tabs.expired_payments": "Erääntyneet maksut",
    "moduleTitle.note_for_al": "Viesti Avartti-ohjaajalle",
    "moduleTitle.confirm": "Vahvista",
    "notification.new_activity_added": "Uusi aktiviteetti on lisätty",
    "notifications.award_leader_has_been_moved": "Avartti-ohjaaja on siirretty",
    "label.award_mode": "Avartin tila",
    "label.phone": "Puhelin",
    "notifications.organization_has_been_updated": "Organisaatio on päivitetty",
    "moduleTitle.assessor": "Arvioija",
    "label.bulk_action_confirmation": "Massatoiminnon vahvistaminen",
    "table.parent_approval": "Huoltajan lupa",
    "label.date_of_delivery": "Päiväys",
    "sidebar.assessors": "Arvioitsija",
    "label.journey_activity": "Seikkailun aktiviteetti",
    "award.inactive_award": "Passiivinen Avartti",
    "label.end_date": "Lopetuspäivä",
    "label.orb_testing": "ORB testaus",
    "label.no_activities": "Ei aktiviteetteja",
    "moduleTitle.please_confirm": "Vahvista",
    "button.login_with_another_account": "Kirjaudu toisella tilillä",
    "tasks.reject_registration": "Tarkasta rekisteröinti",
    "label.submitted_after_date": "Toimitettu",
    "label.update_translations_successful": "",
    "button.assign_leader": "Aseta ohjaaja",
    "table.already_running": "Jo käynnissä",
    "label.no": "Ei",
    "label.count_items_selected": "{count} valittua kohdetta",
    "label.secondary_phone_number": "Toissijainen puhelinnumero",
    "label.my_experience": "Kokemukseni",
    "notifications.adventurous_journey_has_been_approved": "Seikkailutapahtuma on hyväksytty",
    "pageTitle.mro_detail": "Aluetoimiston tiedot",
    "moduleTitle.nao_specific_info": "KAT tiedot",
    "label.preparing_document_for_import": "Valmistaa tiedostoa tuontiin",
    "tasks.observations": "Huomiot",
    "notifications.confirmation_email_has_been_sent": "Vahvistus s-posti on lähetetty",
    "button.restore": "Tallenna",
    "label.importing_file": "Tuo tiedosto",
    "label.or_dont_agree": "Vai oletko eri mieltä?",
    "moduleTitle.award_leader": "Avartti-ohjaaja",
    "label.me": "(minä)",
    "tabs.sub_global_operating_partners": "",
    "button.export_table": "Vie taulukko",
    "organisation.move_award_unit": "Siirrä Avartti-toimijaa",
    "label.file_category": "label.file_category",
    "notifications.connecting_to_server": "Yhdistetään serveriin...",
    "parentalConsent.i_understand_that_a_and_b": "",
    "table.reason": "Syy",
    "pageTitle.contacts": "Yhteystiedot",
    "states.award_leader_approval": "Avartti-ohjaajan valtuutus",
    "meta.payments": "Maksut",
    "label.suboperating_authority": "Alihankkija",
    "route.my_region_office": "Alueellinen toimistoni",
    "states.registration_not_approved": "Rekisteröintiä ei ole hyväksytty",
    "label.direct_entrant": "Suora osallistuja",
    "tabs.all_participants": "Kaikki osallistujat",
    "tabs.payment": "Maksu",
    "label.email_help_activity_name": "Aktiviteetin nimi.",
    "title.update_report": "Päivitä raportti",
    "label.repeat_new_password": "Toista salasana",
    "label.other_roles": "ORB profiili sivu",
    "logs.hours": "tunnit",
    "notifications.spreadsheet_has_been_imported_successfully": "Taulukko on tuotu onnistuneesti",
    "label.bulk_action_question": "Suorita massatoiminto {count} kohteelle?",
    "moduleTitle.personal_details": "Henkilökohtaiset tiedot",
    "label.bulk_action_emailing": "Valittujen osallistujien sähköpostiosoitteet",
    "route.my_events": "Tapahtumani",
    "button.delete_award": "Poista Avartti",
    "errors.include_both_lower_and_upper_case": "Käytä isoja ja pieniä kirjaimia",
    "tabs.removed_participant_registrations": "Poista osallistujan rekisteröityminen",
    "sidebar.mynao": "Minun KAT",
    "tabs.office_details": "Toimiston tiedot",
    "label.major": "Pisin",
    "tabs.documents": "Tiedostot",
    "label.new_password": "Uusi salasana",
    "sidebar.adventure_journey": "Seikkailu",
    "pageTitle.customizations": "Muokkaukset",
    "moduleTitle.assessor_report": "{role} raportti",
    "label.registration_date": "Aloituspäivä",
    "notifications.training_has_been_added": "Harjoitus on lisätty",
    "aj.qualifying": "Varsinainen",
    "moduleTitle.you_have_been_logged_out_session_terminated": "Istunto on päättynyt ja sinut on kirjattu ulos ",
    "award.service": "Vapaaehtoistoiminta",
    "notifications.rp_state_has_been_changed": "Projektin tilaa on muutettu",
    "label.ctest_access": "Pääsy testisivulle",
    "table.created": "Luotu",
    "tasks.revise_task": "Tarkasta tehtävä",
    "button.assign": "Aseta",
    "button.return": "Tarkista",
    "table.status": "Status",
    "button.restore_activity": "Tallenna aktiviteetti",
    "tabs.new_aj_event": "Uusi seikkailutapahtuma",
    "roles.if_staff_viewer": "IAF Staff Viewer",
    "notifications.new_template_has_been_created": "Uusi mallipohja on luotu",
    "global.something_went_wrong": "Jokin meni vikaan",
    "table.expire_day": "Päättymispäivä",
    "tabs.history_log": "Loki historia",
    "label.form_of_payment": "Maksun muoto",
    "button.add_training": "Lisää harjoitus",
    "label.par_reg_cust_note": "Tämän välilehden avulla voit muokata kenttiä, jotka näkyvät osallistujien rekisteröinnissä ja vaikuttavat keräämiesi tietojen määrään. Ota yhteyttä aluetoimistoon, jos haluat tehdä muutoksia - vain IAF Sys -järjestelmänvalvojalla on oikeus tehdä nämä muutokset.",
    "label.my_qualification": "Saavutukset",
    "button.add_new_profile_question": "Lisää uusi profiilikysymys",
    "table.operating_authority": "Yhteistyökumppani",
    "table.aim": "Tavoite",
    "table.awards": "Tunnustus",
    "participant.deactivate_account": "Poista tili käytöstä",
    "table.organization_name": "",
    "label.email_help_award_leader_first_name": "Ohjaajan etunimi.",
    "table.date": "Päivämäärä",
    "tasks.would_you_like_to_delete": "Haluatko poistaa osallistujan?",
    "notifications.configuration_value_has_been_updated": "Konfigurointiarvo on päivitetty",
    "ajTemplates.fill_from_template": "Täytä mallista",
    "contact.send_test_email": "Lähetä testi s-posti",
    "moduleTitle.aj_preparation_and_training": "Harjoitusseikkailu",
    "label.ce_be": "Mukautettavat sähköpostit (sähköpostien käännökset)",
    "button.notify_participant": "Palauta osallistujalle",
    "label.parent_phone": "Vanhemman&#39;s / Huoltajan&#39;s Puhelinnumero",
    "label.nao_regulations": "Säätiön määräykset",
    "award.skills": "Taito",
    "label.reject_application": "hylkää hakemus.",
    "leader.delete_account": "Poista yhteystieto",
    "table.assign": "Aseta",
    "roles.aj_supervisor": "Seikkailun valvoja",
    "label.logout": "Kirjaudu ulos",
    "moduleTitle.award_leader_edit": "Muokkaa Avartti-ohjaajaa",
    "moduleTitle.training": "Harjoitukset",
    "notifications.coordinator_has_been_removed": "Yhteyshenkilö on poistettu",
    "tabs.operating_partners": "",
    "moduleTitle.main_award_leader": "Yhteyshenkilö",
    "label.bulk_action_successful": "{count} kohdetta muokattiin onnistuneesti.",
    "tasks.clear_email_revision": "Tyhjennä sähköpostin tarkistus",
    "table.preparation": "Valmistelu",
    "table.delete": "Poista",
    "label.safeguarding_policy": "",
    "sidebar.reports": "Raportti",
    "pageTitle.sub_global_operating_partners": "",
    "label.is_major_activity_confirmation": "Osallistujalla on jo valittu pitkäkestoisin aktiviteetti toiselta tasolta. Haluatko lisätä vielä toisen?",
    "pageTitle.operating_authorities": "Yhteistyökumppanit",
    "label.delete_participant_award_modal_question_detail": "Haluatko varmasti poistaa {awardLevel} osallistujalta {participantId}?",
    "label.confirmed": "Vahvistettu",
    "notifications.invitation_has_been_sent": "Kutsu on lähetetty",
    "pageTitle.independent_countries": "Itsenäiset valtiot",
    "label.assessors_email": "Arvioitsijan sähköposti",
    "tasks.approve_assessor_registration": "Hyväksy arvioijan rekisteröityminen",
    "table.award_duration": "Avartin kesto",
    "notifications.organization_has_been_moved": "Organisaatio on siirretty",
    "pageTitle.nao_payment": "Avartti-säätiö - Maksu",
    "participant.history_log": "Loki historia",
    "label.rejected_with_note": "Hylätty huomautuksella: \"{note}\"",
    "label.already_running": "Toiminto on käynnissä",
    "button.continue": "Jatkuu",
    "award.no_data_to_show": "Ei näytettävää dataa",
    "participant.send_email_invitation_again_question": "Lähetä s-postikutsu uudelleen?",
    "label.reason_for_changing_assessor": "Syy arvioijan vaihtoon",
    "button.delete": "Poista",
    "moduleTitle.requirements_and_conditions": "Vaatimukset",
    "roles.leader": "Ohjaaja",
    "label.if_download_doesnt": "Tarkista pop lataaminen ei ala automaatti",
    "dashboard.your_todo_list": "Tehtävälistasi",
    "notifications.award_unit_has_been_returned": "Avartti-toimija on tarkastettu",
    "moduleTitle.participant_activities": "Osallistujan aktiviteetit",
    "errors.qualification_or_experience_required": "Edellytämme pätevyyttä tai kokemusta",
    "label.active_leaders": "Aktiiviset ohjaajat",
    "aj.preparation": "Valmistelu",
    "button.change_state": "Vaihda tilannetta",
    "label.current_password": "Nykyinen salasana",
    "pageTitle.global_operating_partners": "",
    "moduleTitle.contact_settings": "Yhteystietoasetukset",
    "button.remove_photo": "Poista kuva",
    "notifications.activity_has_been_setup": "Aktiviteetti on luotu",
    "errors.must_be_more_than": "Täytyy olla vähintään {limit}",
    "table.goal": "tavoite",
    "notifications.coordinator_has_been_set": "Yhteyshenkilö on lisätty",
    "label.cc": "Cc",
    "label.duration": "Pituus",
    "table.actions": "Siirrot",
    "participant.send_email_invitation_again": "Lähetä s-postikutsu uudelleen?",
    "moduleTitle.would_you_like_to_remove_participant": "Haluatko poistaa tämän kirjautumisen?",
    "parentalConsent.i_authorise_employees": "4. Valtuutan Avartti-yksikön työntekijät, virkailijat tai edustajat sekä kaikki muut henkilöt, jotka osallistuvat Avartin järjestämiseen järjestämään osallistujalle tarvittavan lääketieteellisen avun tai hoidon onnettomuuden, vamman, sairauden tai menetyksen sattuessa Avartti-ohjelmassa tai matkustettaessa Avartti-ohjelman toimintaan mukaan lukien, mutta ei rajoittuen, lääkäreiden, sairaanhoitajien tai sairaalan majoituksen.",
    "button.reload_page": "Päivitä sivu",
    "moduleTitle.update_translations": "Päivitä projektin käännökset",
    "label.report_description": "Mukana olevat kentät ja viimeisimmät päivitykset ovat tällä hetkellä saatavilla vain englanniksi. Etsimme ratkaisuja, jotta ne olisivat saatavilla muilla kielillä.",
    "table.email": "S-posti",
    "label.new_goal": "Uusi tavoite",
    "label.participant_survey_parent": "",
    "errors.invalid_email_address": "Virheellinen s-posti",
    "pageTitle.new_contact": "Uusi yhteystieto",
    "sidebar.gops": "",
    "button.manage_participants": "Muokkaa osallistujia",
    "errors.invalid_phone_format": "Väärä puhelinnumero",
    "notifications.login_details_have_been_changed": "Kirjautumistietoja on muutettu",
    "moduleTitle.participant_logs": "Osallistujan lokit",
    "label.save": "Tallenna",
    "label.frequently_asked_questions": "Usein kysytyt kysymykset (UKK)",
    "label.city": "Kunta",
    "notifications.configuration_value_has_been_reset": "Konfigurointiarvo on nollattu",
    "states.office_sign_off": "Avartti-toimijan valtuutus",
    "button.save": "Tallenna",
    "button.import_data_from_selected_file": "Tuo tiedot valitusta tiedostosta",
    "parentalConsent.i_understand_that_the_participant_cannot": "",
    "pageTitle.apiKeys": "API avaimet",
    "label.international_region": "Kansainvälinen alue",
    "tabs.levels": "Tasot",
    "tabs.additional_files": "Lisätiedostot",
    "label.continuation_level": "Jatkava osallistuja",
    "table.adventurous_journey_detail": "Seikkailun tiedot",
    "button.set": "Aseta",
    "label.i_certify_that_as_the_assessor": "Vahvistan roolissani {role}, että osallistuja on tehnyt tarvittavat suoritukset.",
    "table.coordinator": "Yhteyshenkilö",
    "participant.send_confirmation_email_again": "Lähetä vahvistus s-posti uudelleen?",
    "table.report": "Raportti",
    "label.update_translations_results": "Päivitä käännöksien tulokset",
    "table.observation_note": "Huomio viesti",
    "label.view_more": "Katso lisää",
    "notifications.payment_link_has_been_reset": "Maksu linkki on asetettu uudelleen",
    "table.type": "Tyyppi",
    "moduleTitle.updateConfigurationKey": "Päivitä määritysavain",
    "sidebar.independent_award_centers": "Itsenäiset Avartti-toimijat",
    "table.activity_type": "Aktiviteetin muoto",
    "label.awardMode.online": "Online",
    "table.data_state": "Viimeiksi päivitetty",
    "button.generate_report": "Luo raportti",
    "moduleTitle.assessed_by_award_leader": "Arvioitu ohjaajan toimesta",
    "table.child_protection_number": "Child protection number",
    "button.bulk_change": "Massamuutos",
    "label.send_welcome_email": "Lähetä tervetuloa-sposti",
    "label.award_state": "Avartin tilanne",
    "moduleTitle.overview": "Yleiskatsaus",
    "table.aj_detail": "Seikkailun tiedot",
    "pageTitle.tasks_activity_approvals": "Tehtävän hyväksyminen",
    "label.section": "Osio",
    "route.history": "Historia",
    "route.event_participants": "Tapahtuman osallistujat",
    "participant.account_detail": "Tilin asetukset",
    "route.dashboard": "Hallintapaneeli",
    "table.payments": "Maksu",
    "pageTitle.profile": "Profiili",
    "organisation.remove_organisation": "Poista organisaatio",
    "pageTitle.my_organization": "Organisaationi",
    "label.award_leader": "Avartti-ohjaaja",
    "notifications.assessor_has_been_updated": "Arvioitsija on päivitetty",
    "label.participant_personal_reflection": "Osallistujan itsearviointi",
    "button.add_key": "Lisää avain",
    "header.appMotto": "HERTTUA",
    "table.qualifying": "Varsinainen",
    "button.upload": "Lataa",
    "button.resend": "Lähetä uudelleen",
    "label.filename": "Tiedostonnimi",
    "label.change_parental_consent": "Huoltajan lupa paperista sähköiseen",
    "button.cancel": "Peruuta",
    "label.aply_to_all_langs": "Käytä kaikkia kieliä",
    "route.customization": "Mukautukset",
    "errors.minimal_duration_is": "Vähimmäiskesto on 30 min",
    "label.email_help_participant_first_name": "Osallistujan etunimi.",
    "label.participant_status": "Osallistujan tila",
    "award.bronze_level_short": "Pronssi",
    "label.phone_type": "Puhelimen malli",
    "global.night": "yö",
    "button.adventurous_journey_settings": "Seikkailun asetukset",
    "participant.leader_must_be_selected": "Valitse ohjaaja",
    "pageTitle.translationsManagement": "Käännösten hallinta",
    "moduleTitle.user_added_preparation_and_training": "Käyttäjä lisätty Harjoitukset",
    "table.approve": "Hyväksy",
    "label.role_in_organisation": "Rooli organisaatiossa",
    "states.finished": "Valmis",
    "label.created": "Luotu",
    "button.back_to_home": "Takaisin alkuun",
    "label.options": "Valinta",
    "contact.next_level_invitation": "Kutsu seuraavalle tasolle",
    "moduleTitle.activity_detail": "Aktiviteetin tiedot",
    "route.section_signoff": "Osion hyväksyntä",
    "moduleTitle.assign_labels_bulk": "",
    "button.contact_settings": "Yhteystietojen asetukset",
    "label.transation_id": "Arkistointitunnus",
    "notifications.activity_has_been_updated": "Aktiviteetti on päivitetty",
    "sidebar.awards": "Tunnustus",
    "parentalConsent.images_consent": "Vanhempana/huoltajana annan Avartti-säätiölle luvan käyttää alaikäisestä osallistujasta otettuja valokuvia säätiön viestinnässä.",
    "participant.would_you_like_to_delete": "Haluatko poistaa tämän tilin?",
    "roles.user": "Tilastollinen",
    "label.label": "",
    "label.select_sheet": "Valitse tiedosto tietokoneeltasi",
    "global.no_results": "Ei tuloksia",
    "moduleTitle.address_line_2": "Osoite rivi 2",
    "states.awaiting_office_sign_off": "Avartti-toimijan valtuutus",
    "moduleTitle.export": "Vie",
    "moduleTitle.address_line_1": "Osoite rivi 1",
    "notifications.participant_has_been_assigned": "Osallistuja on määritetty",
    "roles.viewer": "Katsoja",
    "label.participants_total": "Kaikki osallistujat",
    "errors.auth_code_is_no_longer_valid": "Valtuutuskoodi ei toimi - se on joko käytetty tai vanhentunut",
    "label.file_is_not_available": "Tiedosto ei ole saatavilla",
    "button.select_template": "Valitse mallipohja",
    "label.payment": "Maksu",
    "award.silver_level_short": "Hopea",
    "table.participant_id": "Osallistuja ID",
    "text.hours_old": "{hours} tuntia vanha",
    "moduleTitle.your_personal_information": "Henkilökohtaiset tiedot",
    "aj.minimum_date_recommendation": "Suositeltu minimi päivämäärä harjoitusseikkailuun ja {name} on",
    "label.date_of_payment": "Maksun päiväys",
    "button.view": "Näytä",
    "label.create_new_label": "",
    "title.confirmation": "Vahvistus",
    "button.set_participants": "Aseta osallistujat",
    "roles.assessor": "Arvioitsija",
    "moduleTitle.coordinator_settings": "Yhteyshenkilön asetukset",
    "label.parent_relationship": "Huoltajuus&#39;s suhde",
    "table.nao": "KAT",
    "notifications.email_has_been_sent": "Sähköposti on lähetetty",
    "label.email_help_participant_full_name": "Osallistujan koko nimi.",
    "sidebar.suboperating_authorities": "Alihankkijat",
    "route.award": "Avartti",
    "label.no_roles": "Ei rooleja",
    "table.files": "Tiedosto",
    "aj.minimum_date_requirements": "Vähimmäisvaatimus varsinaiselle seikkailulle ja {name} on",
    "pageTitle.labels": "",
    "label.participant_is_semi_offline": "Osallistuja on offline",
    "moduleTitle.other_coordinators": "Muut yhteyshenkilöt",
    "button.updateSelectedLanguage": "Valitse kieli",
    "tasks.approve_award_registration": "Hyväksy Avartti kirjautuminen",
    "participant.invite_participant_to_next_level": "Kutsu osallistuja seuraavalle tasolle?",
    "label.twitter": "Twitter",
    "pageTitle.awards": "Tunnustus",
    "warning.award_marked_as_paid": "Varoitus: Tämä Avartin rekisteröinti on merkitty maksetuksi. Tutustu maksu- ja palautusohjeisiin ennen vahvistamista.",
    "table.edit": "Tarkasta",
    "states.change_to_state_warning_missing_hours_to_complete": "Varoitus: minimi tuntimäärä ei ole täyttynyt. Haluatko silti jatkaa?",
    "label.dofe": "Kansainvälinen Avartti",
    "moduleTitle.after_assigning_a_role_to_yourself": "Sinun tulee kirjautua uudelleen vaihdettuasi uuden roolin itsellesi.",
    "label.transaction_id": "Siirron ID",
    "table.suboperating_authority": "Alihankkija",
    "label.participant_survey": "Osallistuja saa kutsun Avartti-säätiön tyytyväisyyskyselyihin.",
    "label.created_by": "Luonut",
    "button.send_confirmation_email_again_question": "Lähetä vahvistus viesti uudelleen",
    "label.email_help_award_leader_email": "Ohjaajan s-posti.",
    "label.name": "Nimi",
    "tabs.gold_level": "Kultataso",
    "pageTitle.award_documents": "Avartti dokumentit",
    "label.online_payments": "Online maksut",
    "label.child_protection_number": "Child protection number",
    "participant.send_password_recovery_email": "Lähetä s-posti salasanan palautuksesta?",
    "notifications.new_log_has_been_added": "Uusi loki on lisätty",
    "moduleTitle.add_gop_role": "",
    "label.organization_name": "Organisaation nimi",
    "pageTitle.my_organization_templates": "Organisaationi mallipohjat",
    "pageTitle.award_leaders": "Avartti-ohjaaja",
    "label.status": "Status",
    "label.street": "Katu",
    "roles.if_staff_superuser": "IAF Staff Superuser",
    "table.licence_holder": "Lisenssin hallitsija",
    "label.created_at": "Luotu",
    "table.section": "Osio",
    "table.system_rights": "Oikeudet",
    "label.iac_type": "IAC Type",
    "label.other": "Muu",
    "moduleTitle.login": "Kirjaudu",
    "label.no_data_to_show": "Ei näytettävää dataa",
    "aj.cannot_modify_award_level_if_participants_are_assigned": "Avartti-tasoa ei voi muuttaa jos osallistujat on jo määritetty Seikkailuun",
    "tabs.waiting_payments": "Odottavat maksut",
    "global.supervisor": "Valvoja",
    "notifications.new_role_has_been_added": "Uusi rooli on lisätty",
    "award.silver_level": "Hopeataso",
    "heading.change_awards_mode": "Muuta Avartin tilaa",
    "button.save_changes": "Tallenna muutokset",
    "organisation.would_you_like_to_move_award_unit": "Mihin haluat siirtää organisaation?",
    "label.fields": "label.fields",
    "label.email_help_organization_name": "Avartti-yksikön nimi.",
    "pageTitle.mro_related_detail": "Aluetoimisto - Tiedot",
    "table.started_at": "Aloitettu",
    "parentalConsent.i_consent_to_the_award_unit": "2. Annan luvan, että Avartti-yksikkö ja henkilöt, jotka osallistuvat Avartin järjestämiseen saavat kuljettaa tarvittaessa osallistujaa Avartin toimintoihin. Ymmärrän, että Avartti-yksikkö ilmoittaa minulle etukäteen, milloin ja missä tällainen matkustaminen tapahtuu.",
    "logs.minutes": "Minuutit",
    "label.total_participants": "Kaikki osallistujat",
    "moduleTitle.contact_info": "Yhteystiedot",
    "table.payment_link": "Maksu linkki",
    "errors.please_contact_your_local_award_staff": "Ota yhteyttä Avartin työntekijöihin."
}